<template>
    <div class="rating-stars d-flex align-center">
        <v-icon
            v-for="star in 5"
            :key="star"
            :size="size"
            :color="star <= displayValue ? color : emptyColor"
            @click="handleClick(star)"
            @mouseover="handleHover(star)"
            @mouseleave="handleLeave"
            :class="{ 'cursor-pointer': !readonly }"
        >
            {{ displayValue >= star ? 'mdi-star' : 'mdi-star-outline' }}
        </v-icon>
        <span v-if="showValue && value > 0" class="ml-2 rating-value">{{ value.toFixed(1) }}</span>
    </div>
</template>

<script>
export default {
    name: 'RatingStars',
    props: {
        value: {
            type: Number,
            default: 0
        },
        readonly: {
            type: Boolean,
            default: true
        },
        size: {
            type: [String, Number],
            default: 24
        },
        color: {
            type: String,
            default: '#FFD700'
        },
        emptyColor: {
            type: String,
            default: '#E0E0E0'
        },
        showValue: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hoverValue: 0
        }
    },
    computed: {
        displayValue() {
            if (!this.readonly && this.hoverValue > 0) {
                return this.hoverValue;
            }
            return Math.round(this.value);
        }
    },
    methods: {
        handleClick(star) {
            if (!this.readonly) {
                this.$emit('input', star);
            }
        },
        handleHover(star) {
            if (!this.readonly) {
                this.hoverValue = star;
            }
        },
        handleLeave() {
            this.hoverValue = 0;
        }
    }
}
</script>

<style scoped>
.rating-stars {
    display: inline-flex;
}
.cursor-pointer {
    cursor: pointer;
}
.rating-value {
    font-weight: 600;
    color: #333;
}
</style>
